/**
 * The dev cat-switcher -- "Playing as" and the five base cats.  Hidden until
 * the debug overlay reveals it (debug.js is handed the panel): picking a cat
 * is a developer affordance, and a panel naming five of them is the first
 * thing a player would look at instead of the street.  #cat-name and the
 * [data-cat] buttons travel out as handles for context.js to drive.
 */
import "./hud.css";
import { mount } from "./dom.js";

export function mountHud(leftStack) {
  const hud = mount(`
  <div id="hud" class="panel hidden">
    <div>
      <div class="label">Playing as</div>
      <div id="cat-name">Loading…</div>
    </div>
    <div class="switch">
      <button data-cat="0" type="button">1 · Sandy</button>
      <button data-cat="1" type="button">2 · Ginger</button>
      <button data-cat="2" type="button">3 · Grey</button>
      <button data-cat="3" type="button">4 · Toon</button>
      <button data-cat="4" type="button">5 · Tabby</button>
    </div>
  </div>`, leftStack);
  return { hud,
           catName: hud.querySelector("#cat-name"),
           catButtons: [...hud.querySelectorAll("[data-cat]")] };
}
